import { render } from "./Skikaart.vue?vue&type=template&id=0dc180b5&scoped=true"
import script from "./Skikaart.vue?vue&type=script&lang=js"
export * from "./Skikaart.vue?vue&type=script&lang=js"

import "./Skikaart.vue?vue&type=style&index=0&id=0dc180b5&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc180b5"]])

export default __exports__